import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GlobalNavigationService } from '@app/shared/services/global-navigation.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-learning-view',
  templateUrl: './learning-view.component.html',
  styleUrls: ['./learning-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningViewComponent implements OnInit {
  constructor(
    private globalNavigationService: GlobalNavigationService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.globalNavigationService.register({
      title: this.translateService.instant('Core_Search'),
    });
  }

  public ngOnDestroy(): void {
    this.globalNavigationService.reset();
  }
}
